/* Progressive enhancement only; native Shopify product forms perform all purchases. */
(() => {
  function syncSticky() {
    document.querySelectorAll('product-info').forEach(info => {
      const bar = info.querySelector('.geena-mobile-buy');
      if (!bar) return;
      const source = info.querySelector('product-form button[name="add"]');
      const button = bar.querySelector('button');
      const price = info.querySelector('[id^="price-"] .price-item--sale') || info.querySelector('[id^="price-"] .price-item--regular');
      if (button && source) { const label = source.querySelector('span')?.textContent.trim() || source.textContent.trim(); if(button.disabled !== source.disabled) button.disabled = source.disabled; if(button.textContent !== label) button.textContent = label; }
      if (price) { const target=bar.querySelector('[data-sticky-price]'); const text=price.textContent.trim(); if(target.textContent !== text) target.textContent=text; }
    });
  }
  document.addEventListener('click', event => {
    const sticky = event.target.closest('[data-geena-buy]');
    if (sticky) { const source = sticky.closest('product-info')?.querySelector('product-form button[name="add"]'); if (source && !source.disabled) source.click(); }
    const wish = event.target.closest('[data-geena-wish]');
    if (wish) {
      try {
        const key = 'geena-native-wishlist';
        const parsed = JSON.parse(localStorage.getItem(key) || '[]');
        const handles = Array.isArray(parsed) ? parsed.filter(x=>typeof x==='string') : [];
        const handle = wish.dataset.geenaWish;
        const selected = handles.includes(handle);
        localStorage.setItem(key, JSON.stringify(selected ? handles.filter(h=>h!==handle) : [...handles, handle].slice(-100)));
        wish.setAttribute('aria-pressed', String(!selected));
        wish.textContent = selected ? 'Save to my wishlist' : 'Saved to my wishlist';
        window.dispatchEvent(new CustomEvent('geena:wishlist-change'));
      } catch { wish.textContent = 'Your browser cannot save this wishlist'; }
    }
  });
  function init() {
    syncSticky();
    document.querySelectorAll('product-info').forEach(info=>{
      if(info.dataset.geenaObserved) return;
      info.dataset.geenaObserved='true';
      new MutationObserver(syncSticky).observe(info,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
    });
    try { const saved=JSON.parse(localStorage.getItem('geena-native-wishlist')||'[]'); document.querySelectorAll('[data-geena-wish]').forEach(b=>{if(Array.isArray(saved)&&saved.includes(b.dataset.geenaWish)){b.setAttribute('aria-pressed','true');b.textContent='Saved to my wishlist';}}); } catch {}
  }
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
